import React, { Fragment } from 'react';
interface PageLayoutProps {
  title: string;
  /** Supporting subtitle shown below title */
  description?: string;
  /** Alias for description */
  subtitle?: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  breadcrumbs?: Array<{
    label: string;
    href?: string;
  }>;
}
export function PageLayout({
  title,
  description,
  subtitle,
  actions,
  children,
  className = '',
  breadcrumbs
}: PageLayoutProps) {
  const displayDescription = description ?? subtitle;
  return <div className={`flex flex-col h-full min-h-0 ${className}`} data-id="element-6083">
      {/* Header */}
      <div className="flex-shrink-0 px-4 py-3 sm:px-6 sm:py-5 border-b border-slate-200 bg-white/80 backdrop-blur-sm" data-id="element-6084">
        {breadcrumbs && breadcrumbs.length > 0 && <div className="flex items-center gap-1.5 mb-2" data-id="element-6085">
            {breadcrumbs.map((crumb, i) => <Fragment key={i} data-id="element-6086">
                {i > 0 && <span className="text-slate-300 text-xs" data-id="element-6087">/</span>}
                <span className="text-xs text-slate-400" data-id="element-6088">{crumb.label}</span>
              </Fragment>)}
          </div>}
        <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-3" data-id="element-6089">
          <div className="min-w-0 flex-1" data-id="element-6090">
            <h1 className="text-base sm:text-xl font-black text-slate-900 leading-tight" data-id="element-6091">
              {title}
            </h1>
            {displayDescription && <p className="text-sm text-slate-500 mt-0.5 line-clamp-1 sm:line-clamp-none" data-id="element-6092">
                {displayDescription}
              </p>}
          </div>
          {actions && <div className="flex items-center gap-2 flex-shrink-0" data-id="element-6093">
              {actions}
            </div>}
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto px-4 py-4 sm:px-6 sm:py-5" data-id="element-6094">
        {children}
      </div>
    </div>;
}